<script setup lang="ts">
import { ModalConfirmation } from '@shared/ui/modals'

import { useDeleteUser } from '../../model/delete-user.hook'

defineOptions({
  name: 'ModalDeleteUser',
})

const { isOpen, isDeleting, confirm, cancel } = useDeleteUser()
</script>

<template>
  <ModalConfirmation
    :show="isOpen"
    mode="delete"
    title="Delete user?"
    detail="Are you sure you want to delete this user? All of data will be permanently removed. This action cannot be uncompleted."
    button-title="Delete user"
    :loading="isDeleting"
    @click:confirm="confirm"
    @click:cancel="cancel"
  />
</template>
